import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["document"]
  static optionalTargets = ["form"]

  connect() {
    this.updateHiddenFields()
  }

  remove(event) {
    event.preventDefault()
    
    const documentId = event.currentTarget.dataset.documentId
    
    if (!confirm("Dokument wirklich löschen?")) {
      return
    }

    // Entferne das Dokument aus dem DOM
    const documentElement = this.documentTargets.find(el => el.dataset.documentId === documentId)
    if (documentElement) {
      documentElement.remove()
    }
    
    // Aktualisiere die versteckten Felder im Formular
    this.updateHiddenFields()
    
    // Zeige Erfolgsmeldung
    this.showNotification("Dokument wurde aus dem Formular entfernt", "success")
  }

  updateHiddenFields() {
    // Aktualisiere die versteckten Felder für bestehende Dokumente
    const form = this.hasFormTarget ? this.formTarget : null
    if (!form) {
      // Wenn kein Formular vorhanden ist, nur die DOM-Elemente aktualisieren
      return
    }

    // Entferne alle bestehenden versteckten Felder für files
    form.querySelectorAll('input[type="hidden"][name*="[files]"]').forEach(field => {
      field.remove()
    })

    // Füge neue versteckte Felder für verbleibende Dateien hinzu
    this.documentTargets.forEach(documentElement => {
      const documentId = documentElement.dataset.documentId
      const signedId = documentElement.dataset.signedId
      
      if (documentId && signedId) {
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = 'quote[files][]'
        hiddenField.value = signedId
        form.appendChild(hiddenField)
      }
    })
  }

  showNotification(message, type = "info") {
    // Einfache Benachrichtigung - kann durch Toast-Component ersetzt werden
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${
      type === 'success' ? 'bg-green-500 text-white' : 
      type === 'error' ? 'bg-red-500 text-white' : 
      'bg-blue-500 text-white'
    }`
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    // Nach 3 Sekunden entfernen
    setTimeout(() => {
      notification.remove()
    }, 3000)
  }
}
